module.exports = __webpack_public_path__ + "img/four.19b5119c.png";